import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/regionsReducer";
import rootSaga from "./redux/regionsSagas";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import { RegionsModule } from "./RegionsModule";

const Regions = (props) => {
  const { notifications, ...rest } = props;

  return (
    <Provider store={createReduxStore(reducer, "regions", rootSaga)}>
      <ErrorBoundary moduleName="regions" {...notifications}>
        <RegionsModule params={rest} />
      </ErrorBoundary>
    </Provider>
  );
};

export default Regions;
